
import { RedDelete } from "@/constants/images";
import CommonButton from "./CommonButton";
import CommonModal from "./CommonModal";

const DeleteModal = ({isOpen, handleClose, handleOnDelete, data='Are you sure want to delete this?', buttonContent='Yes', IsIcon=false, icon})=>{
return(

    <CommonModal
    isOpen={isOpen}
    handleClose={handleClose}
    maxWidth={"300px"}
    className={"common-modal-title"}
  >
    <div className="modal-main-container basic-form ">
      <div
        className={`${"d-flex align-items-center justify-content-center "
        }`}
      >
        <img
          src={IsIcon ? icon : RedDelete}
          alt="Delete"
          width={"100px"}
          height={"100px"}
        />
      </div>
      <div className="text-center mt-2 mb-2">
       {data}
      </div>
    </div>
    <div className="modal-btn">
      
      <CommonButton
        className={"small-btn mx-auto"}
        onClick={() => handleOnDelete()}
      >
        {buttonContent}
      </CommonButton>
      
    </div>
  </CommonModal>
)
}
export default DeleteModal;